export const BLUESUN_OFFICIAL_ICON = "/brand/bluesun-official-icon.png";

export const BLUESUN_WEBSITE = "https://www.bluesunpv.com/zh/";
